import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './PartnerHeadReadMode.module.scss'

interface IPartnerHeadReadModeProps {
  salesCount: Nullable<number>
  serviceCount: Nullable<number>
}

export const PartnerHeadReadMode: FC<IPartnerHeadReadModeProps> = ({
  salesCount,
  serviceCount,
}) => {
  const formattedSalesCount = useMemo(() => {
    if (salesCount === null) {
      return '-'
    }

    return getFormattedFinance(salesCount, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [salesCount])

  const formattedServiceCount = useMemo(() => {
    if (serviceCount === null) {
      return '-'
    }

    return getFormattedFinance(serviceCount, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [serviceCount])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedSalesCount}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.salesCountLabel} span />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedServiceCount}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.servicesCountLabel} span />
        </div>
      </div>
    </div>
  )
}
